import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { VIEW_PATH } from '../../../../config/paths';

const EditViewButton = ({ viewId }) => (
  <Link className="btn btn-primary" to={`${VIEW_PATH}/${viewId}/edit`}>
    Editar
  </Link>
);

EditViewButton.propTypes = {
  viewId: PropTypes.number.isRequired,
};

export default EditViewButton;